<template>
  <div>
    <div class="left-wrapper">
      <ul class="account-list list-box">
        <li>
          <router-link to="/s-mart/personal_center/message/" exact>所有留言</router-link>
        </li>
        <li>
          <router-link to="/s-mart/personal_center/message/unread">未读留言(<span class="unread">{{total.unread_cnt}}</span>)</router-link>
        </li>
      </ul>
    </div>
    <div class="right-wrapper">
      <router-view :total="total"></router-view>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    data() {
      return {
        total: {
          unread_cnt: 0  // 未读数量
        }
      }
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  .unread{
    color: #ff6600;
  }
  .active{
    .unread{
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// message_log.vue?006c913f